module.exports = __webpack_public_path__ + "static/media/stopwatch.91bda134.svg";